import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

interface PortalProps {
  children: React.ReactNode;
  container?: HTMLElement;
}

/**
 * Renders children into a DOM node outside the parent tree (for dropdowns/tooltips).
 *
 * @param props - Portal children and optional mount container
 * @returns Portaled children when mounted
 */
const Portal = ({ children, container = document.body }: PortalProps) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);

  return mounted ? createPortal(children, container) : null;
};

export default Portal;
